import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function Employees({ children }) {
  useInjectSaga({ key: 'employees', saga });
  useInjectReducer({ key: 'employees', reducer });

  return React.Children.only(children);
}

Employees.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withEmployees } from './withEmployees';
export default compose(withConnect, memo)(Employees);
